module.exports = __webpack_public_path__ + "img/kinetikos-hero-dashboard.e9f89ff1.png";